import { render, staticRenderFns } from "./policy-detail.vue?vue&type=template&id=709f1820&scoped=true"
import script from "./policy-detail.vue?vue&type=script&lang=js"
export * from "./policy-detail.vue?vue&type=script&lang=js"
import style0 from "./policy-detail.vue?vue&type=style&index=0&id=709f1820&prod&lang=scss&scoped=true"
import style1 from "./policy-detail.vue?vue&type=style&index=1&id=709f1820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709f1820",
  null
  
)

export default component.exports